'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Array$BsBastet = require("bs-bastet/bastet/src/Array.bs.js");
var String$BsBastet = require("bs-bastet/bastet/src/String.bs.js");
var Relude_List_Base = require("./list/Relude_List_Base.bs.js");
var Relude_Array_Base = require("./array/Relude_Array_Base.bs.js");
var Relude_List_Instances = require("./list/Relude_List_Instances.bs.js");
var Relude_Array_Instances = require("./array/Relude_Array_Instances.bs.js");

function emptyLazy(param) {
  return /* [] */0;
}

function fromList(a) {
  return a;
}

function toList(a) {
  return a;
}

var mkString = Curry._1(Relude_List_Instances.intercalate, String$BsBastet.Monoid);

var List = {
  emptyLazy: emptyLazy,
  length: Relude_List_Instances.length,
  isEmpty: Relude_List_Base.isEmpty,
  isNotEmpty: Relude_List_Base.isNotEmpty,
  head: Relude_List_Base.head,
  tail: Relude_List_Base.tail,
  tailOrEmpty: Relude_List_Base.tailOrEmpty,
  uncons: Relude_List_Base.uncons,
  prepend: Relude_List_Base.prepend,
  append: Relude_List_Base.append,
  concat: Relude_List_Instances.concat,
  reverse: Relude_List_Base.reverse,
  mkString: mkString,
  zip: Relude_List_Base.zip,
  zipWith: Relude_List_Base.zipWith,
  fromArray: Relude_List_Instances.fromArray,
  fromList: fromList,
  toArray: Relude_List_Instances.toArray,
  toList: toList,
  eqBy: Relude_List_Instances.eqBy,
  showBy: Relude_List_Instances.showBy,
  Functor: Relude_List_Instances.Functor,
  Apply: Relude_List_Instances.Apply,
  Applicative: Relude_List_Instances.Applicative,
  Monad: Relude_List_Instances.Monad,
  Foldable: Relude_List_Instances.Foldable,
  Traversable: Relude_List_Instances.Traversable,
  Eq: Relude_List_Instances.Eq,
  Show: Relude_List_Instances.Show
};

function emptyLazy$1(param) {
  return [];
}

function fromArray(a) {
  return a;
}

function toArray(a) {
  return a;
}

var mkString$1 = Curry._1(Relude_Array_Instances.intercalate, String$BsBastet.Monoid);

var $$Array = {
  emptyLazy: emptyLazy$1,
  length: Relude_Array_Base.length,
  isEmpty: Relude_Array_Base.isEmpty,
  isNotEmpty: Relude_Array_Base.isNotEmpty,
  head: Relude_Array_Base.head,
  tail: Relude_Array_Base.tail,
  tailOrEmpty: Relude_Array_Base.tailOrEmpty,
  uncons: Relude_Array_Base.uncons,
  prepend: Relude_Array_Base.prepend,
  append: Relude_Array_Base.append,
  concat: Relude_Array_Instances.concat,
  reverse: Relude_Array_Base.reverse,
  mkString: mkString$1,
  zip: Relude_Array_Base.zip,
  zipWith: Relude_Array_Base.zipWith,
  fromArray: fromArray,
  fromList: Relude_Array_Instances.fromList,
  toArray: toArray,
  toList: Relude_Array_Instances.toList,
  eqBy: Relude_Array_Instances.eqBy,
  showBy: Relude_Array_Instances.showBy,
  Functor: Relude_Array_Instances.Functor,
  Apply: Relude_Array_Instances.Apply,
  Applicative: Relude_Array_Instances.Applicative,
  Monad: Relude_Array_Instances.Monad,
  Foldable: Relude_Array_Instances.Foldable,
  Traversable: Array$BsBastet.Traversable,
  Eq: Relude_Array_Instances.Eq,
  Show: Relude_Array_Instances.Show
};

exports.List = List;
exports.$$Array = $$Array;
/* mkString Not a pure module */
